export const BRAND = {
  company: "Gruham",
  name: "Gruham",
  product: "Kitchen Platform Fan",
  tagline: "For mom by mom",
  email: "support@gruham.in",
  phone: "+91 9664527720",
  phoneDigits: "919664527720",
  hours: "Monday to Saturday, 9AM to 7PM",
  address:
    "Copper Build, Police Parade ground road, Nana Mauva, Rajkot, Gujarat, 360005, India",
  returnAddress:
    "A tower - Copper Elegance apartment, opp police parade HQ, near swarnabhoomi, Rajkot, Gujarat, 360005",
  whatsappMessage: "Hi Gruham, I'm interested in the Kitchen Platform Fan",
};

export const PRICING = {
  mrp: 4499,
  price: 3300,
  get discountPercent() {
    return Math.round(((this.mrp - this.price) / this.mrp) * 100);
  },
};

export const PRODUCT_FEATURES = [
  "Countertop design — fits any Indian kitchen",
  "Plug & Play — NO installation & NO battery charging",
  "More practical than ceiling fan, mist fan and all market options",
  "1-Year Warranty",
  "7-Day Money-Back Guarantee",
  "45W energy efficient · ~50 paise / hour",
];

export const TECH_SPECS = [
  { label: "Oscillation", value: "90 degrees" },
  { label: "Max Speed", value: "1400 RPM" },
  { label: "Voltage", value: "220–240 V" },
  { label: "Current Type", value: "A.C. Current" },
  { label: "Speed settings", value: "3" },
  { label: "Power", value: "45 W" },
  { label: "Air delivery", value: "4.6 M/s" },
];

export const TESTIMONIALS = [
  {
    quote:
      "I used to change clothes 5 times while cooking. It was so exhausting. Now I'm comfortable through the whole meal.",
    quoteGu:
      "હું રસોઈ કરતી વખતે 5 વખત કપડાં બદલતી. હવે આખા ભોજન દરમિયાન આરામદાયક છું.",
    name: "Priya",
    location: "Mumbai",
    relation: "Housewife",
    rating: 5,
  },
  {
    quote:
      "My mom wouldn't eat because she was too hot. Now she actually enjoys cooking — and finishes her food.",
    quoteGu:
      "મારી મા ગરમીને કારણે ખાતી નહોતી. હવે તેને રસોઈ બનાવવી ગમે છે — અને જમે છે.",
    name: "Rahul",
    location: "Bangalore",
    relation: "Bought for Mom",
    rating: 5,
  },
  {
    quote:
      "I thought I had to suffer. That's what moms do, right? Turns out... I didn't.",
    quoteGu:
      "મને લાગ્યું હું સહન કરતી રહીશ. માતા તો આવી જ હોય છે ને? પણ એવું નથી.",
    name: "Sheila",
    location: "Delhi",
    relation: "Mother of 2",
    rating: 5,
  },
  {
    quote: "Finally, someone gets what we actually need in an Indian kitchen.",
    quoteGu: "આખરે કોઈએ સમજ્યું કે ભારતીય રસોડામાં અમને શું જોઈએ.",
    name: "Preeti",
    location: "Delhi",
    relation: "Customer",
    rating: 5,
  },
  {
    quote: "Bought for my mom. She won't stop thanking me. Worth every rupee.",
    quoteGu: "મા માટે લીધો. તે ખુશ થઈ ગઈ. દરેક રૂપિયો વસૂલ.",
    name: "Akshay",
    location: "Bangalore",
    relation: "Bought for Mom",
    rating: 5,
  },
];

export const COMPARISONS = [
  {
    title: "vs Regular Table Fan",
    titleGu: "ટેબલ ફેન સામે",
    others: "Pushes hot air around. No cooling. Loud at high speed.",
    othersGu:
      "ગરમ હવા જ ફેરવે છે. ઠંડક નહીં. ઊંચી ગતિએ ઘોંઘાટ કરે છે.",
    ours: "Cooled airflow focused on you. Whisper quiet. Built for kitchens.",
    oursGu:
      "તમારા પર કેન્દ્રિત ઠંડી હવા. એકદમ શાંત. રસોડા માટે બનાવેલ.",
  },
  {
    title: "vs Pedestal Fan",
    titleGu: "પેડેસ્ટલ ફેન સામે",
    others: "Bulky. Hard to move. Wires across the floor. Tips easily.",
    othersGu:
      "વજનદાર. ખસેડવું મુશ્કેલ. વાયર પગ વચ્ચે. પડી શકે છે.",
    ours: "Countertop, only 800g. Stable base. Move it anywhere in seconds.",
    oursGu:
      "કાઉન્ટરટોપ, માત્ર 800 ગ્રામ. સ્થિર. થોડી જ સેકન્ડમાં ખસેડી શકાય.",
  },
  {
    title: "vs Air Cooler",
    titleGu: "એર કૂલર સામે",
    others: "Adds humidity. Heavy. Needs water refill. Expensive.",
    othersGu:
      "ભેજ વધારે. ભારે. પાણી ભરવું પડે. મોંઘું.",
    ours: "Dry cool airflow. No water. Affordable. Just plug in and use.",
    oursGu:
      "સૂકી ઠંડી હવા. પાણી નહીં. પોસાય તેવું. પ્લગ કરો, ચાલુ કરો.",
  },
  {
    title: "vs Ceiling Fan",
    titleGu: "સીલિંગ ફેન સામે",
    others:
      "Cools the whole room — wastes energy. Doesn't reach the stove area.",
    othersGu:
      "આખા રૂમને ઠંડક આપે — શક્તિ બગાડે. સ્ટવ સુધી પહોંચતું નથી.",
    ours: "Cools YOU, not the room. 50 paise/hour. Direct relief while cooking.",
    oursGu:
      "આખા રૂમ નહીં, તમને ઠંડક. 50 પૈસા/કલાક. રસોઈ વખતે સીધી રાહત.",
  },
];

export const FAQS = [
  {
    q: "Why better than other fans?",
    qGu: "અન્ય ફેન કરતાં કેમ સારું?",
    a:
      "This fan is designed such that it does not blow the stove flame away and also covers a wide area of your body. So it can be used even during peak cooking. Ceiling fans blow away the flame, and other small fans need regular charging and cover only small areas of the body.",
    aGu:
      "આ ફેન એવી રીતે ડિઝાઇન થયું છે કે તે સ્ટવની જ્યોતને ઉડાવતું નથી અને શરીરના મોટા ભાગ સુધી ઠંડક પહોંચાડે છે — રસોઈની પીક વખતે પણ. સીલિંગ ફેન જ્યોત ઉડાડે છે, નાના ફેન રોજ ચાર્જ કરવા પડે અને શરીરના નાના ભાગ પર જ ઠંડક આપે.",
  },
  {
    q: "How loud is it?",
    qGu: "તે કેટલું ઘોંઘાટિયું છે?",
    a:
      "45dB on full speed — quieter than your refrigerator. On medium, barely audible.",
    aGu:
      "ફુલ સ્પીડ પર 45dB — ફ્રિજ કરતા ઓછું. મીડિયમ પર લગભગ સંભળાય નહીં.",
  },
  {
    q: "What if I don't like it?",
    qGu: "જો મને નહીં ગમે તો?",
    a:
      "7-day money-back guarantee. No questions asked. If it's not right for you, we refund completely.",
    aGu:
      "7-દિવસની મની-બેક ગેરંટી. કોઈ સવાલ નહીં. પૂરો રિફંડ.",
  },
  {
    q: "How much electricity does it use?",
    qGu: "વીજળી કેટલી વાપરે છે?",
    a:
      "Only 45W. About 50 paise per hour. Even 3 hours daily is under ₹50/month.",
    aGu:
      "માત્ર 45W. કલાકના આશરે 50 પૈસા. દિવસના 3 કલાક ચલાવો તો પણ મહિને ₹50 થી ઓછું.",
  },
  {
    q: "Is it safe in a kitchen?",
    qGu: "શું તે રસોડામાં સુરક્ષિત છે?",
    a:
      "Completely safe. Normal household voltage, stable base, no exposed motor parts.",
    aGu:
      "સંપૂર્ણ સુરક્ષિત. સામાન્ય વોલ્ટેજ, સ્થિર બેઝ, ખુલ્લા મોટર ભાગ નહીં.",
  },
];

export const TRUST_BADGES = [
  {
    key: "free_shipping",
    title: "Free Shipping",
    titleGu: "ફ્રી ડિલિવરી",
    body: "Pan-India · No hidden charges",
    bodyGu: "આખા ભારતમાં · કોઈ વધારાનો ચાર્જ નહીં",
    icon: "Truck",
  },
  {
    key: "return",
    title: "7-Day Easy Return",
    titleGu: "7-દિવસનું સરળ રિટર્ન",
    body: "Don't like it? Full refund.",
    bodyGu: "ન ગમે તો પૂરો રિફંડ.",
    icon: "RotateCcw",
  },
  {
    key: "cod",
    title: "Cash on Delivery",
    titleGu: "કેશ ઓન ડિલિવરી",
    body: "Pay only after you receive it",
    bodyGu: "મળ્યા પછી જ પૈસા ચૂકવો",
    icon: "Wallet",
  },
  {
    key: "warranty",
    title: "1-Year Warranty",
    titleGu: "1-વર્ષની વોરંટી",
    body: "We stand behind every fan",
    bodyGu: "દરેક ફેન પર અમારી ગેરંટી",
    icon: "ShieldCheck",
  },
];
